/**
 * Disposicoes da lista de operacoes (03/11/2026).
 *
 * A lista tinha treze colunas pela ordem do OnPoint, com as acoes na primeira, e rolava
 * para o lado em qualquer tela comum. O dono pediu a lista ajustavel e as acoes por
 * ultimo. Como na lista de tomadores, a largura medida escolhe a disposicao: os dados
 * sao os mesmos em todas, o que muda e como se agrupam na mesma celula. Nenhuma rola
 * para o lado, e as acoes ficam sempre na ultima coluna.
 */
export type EncaixeDaListaDeOperacoes = 'ampla' | 'reunida' | 'estreita' | 'minima';

/** Larguras da area da lista, ja sem menu e margens, em pixels. */
export const LARGURA_DAS_OPERACOES_AMPLA = 1500;
export const LARGURA_DAS_OPERACOES_REUNIDA = 1000;
export const LARGURA_DAS_OPERACOES_ESTREITA = 640;

export function encaixarListaDeOperacoes(
  disponivel: number,
): EncaixeDaListaDeOperacoes {
  // Antes da primeira medida nao ha largura: nada indica que falta espaco.
  if (disponivel <= 0 || disponivel >= LARGURA_DAS_OPERACOES_AMPLA) return 'ampla';
  if (disponivel >= LARGURA_DAS_OPERACOES_REUNIDA) return 'reunida';
  if (disponivel >= LARGURA_DAS_OPERACOES_ESTREITA) return 'estreita';
  return 'minima';
}
